export const consoleLogLevels = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error'
}
